import React, { useEffect, useRef } from 'react';

// Text number that should NOT be tracked by CallRail
const TEXT_NUMBER = '2149087644';

/**
 * TextLink Component
 * 
 * This component creates an SMS link that bypasses CallRail's phone number swapping.
 * CallRail's swap.js runs on page load and replaces phone numbers in the DOM.
 * By setting the href via JavaScript after a delay, we ensure CallRail doesn't swap it.
 */
const TextLink = ({ children, className = '' }) => {
  const linkRef = useRef(null);

  useEffect(() => {
    // Set the href after CallRail has run (typically within 100ms of page load)
    const timer = setTimeout(() => {
      if (linkRef.current) {
        linkRef.current.href = `sms:${TEXT_NUMBER}`;
      }
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = (e) => {
    // Fallback: if href wasn't set, open SMS directly
    e.preventDefault();
    window.location.href = `sms:${TEXT_NUMBER}`;
  };

  return (
    <a 
      ref={linkRef}
      href="#text" 
      onClick={handleClick}
      className={className}
      data-noswap="true"
    >
      {children}
    </a>
  );
};

export default TextLink;
